// Трекер (README §5): доски со счётчиками в меню, доска/список/архив в рабочей области.
// Задачи — заметки type: task/message на сервере (docs/api-tracker-v3.md).

import { lazy, useEffect } from 'react'
import { SideMenu } from '../../ui/SideMenu'
import type { SideItem } from '../../ui/SideMenu'
import type { SectionModule } from '../types'
import { useTracker } from './store'

const View = lazy(() => import('./TrackerView'))

function useCounts() {
  const items = useTracker((s) => s.items)
  const boards = useTracker((s) => s.config?.boards)
  const open = new Map<string, number>()
  const closed = new Map<string, number>()
  for (const it of items) {
    const m = it.closed ? closed : open
    m.set(it.board, (m.get(it.board) ?? 0) + 1)
  }
  return { boards: boards ?? [], open, closed }
}

function Sidebar() {
  const load = useTracker((s) => s.load)
  const loaded = useTracker((s) => s.loaded)
  const current = useTracker((s) => s.board)
  const view = useTracker((s) => s.view)
  const setBoard = useTracker((s) => s.setBoard)
  const setView = useTracker((s) => s.setView)
  const addBoard = useTracker((s) => s.addBoard)
  const { boards, open, closed } = useCounts()

  // меню может показаться раньше рабочей области (ленивый чанк) — данные нужны и ему
  useEffect(() => {
    if (!loaded) void load()
  }, [loaded, load])

  const items: SideItem[] = [
    ...boards.map((b) => ({
      id: `b:${b.id}`,
      label: b.title,
      meta: String(open.get(b.id) ?? 0),
      active: b.id === current && view !== 'archive',
      title: b.title,
      onSelect: () => setBoard(b.id),
    })),
    {
      id: 'archive',
      label: 'архив',
      meta: String(closed.get(current) ?? 0),
      active: view === 'archive',
      title: 'закрытые задачи доски',
      onSelect: () => setView('archive'),
    },
    { id: 'add', label: '+ доска', action: true, onSelect: () => void addBoard() },
  ]

  return (
    <SideMenu
      screen="tracker"
      sections={[{
        id: 'boards',
        title: 'Доски',
        count: String(boards.length),
        onAdd: () => void addBoard(),
        addTitle: 'новая доска',
        items,
      }]}
    />
  )
}

function useRail() {
  const current = useTracker((s) => s.board)
  const items = useTracker((s) => s.items)
  const n = items.filter((it) => it.board === current && !it.closed).length
  return { count: String(n), tip: `открытых задач: ${n}` }
}

const tracker: SectionModule = { Sidebar, View, useRail }
export default tracker
